import { LearningIndicatorIcon } from "components/svg-icons";
import ButtonSymphony from "../../../elements/ButtonSymphony";
import { clsx } from "modules/Utils";
import { CSSProperties } from "react";

interface LearningIndicatorProps {
    className: string;
    style?: CSSProperties;
    text: string;
    onClick: () => void;
}

const LearningIndicator = ({
    className,
    style,
    text,
    onClick
}: LearningIndicatorProps) => {
    return (
        <ButtonSymphony
            className={clsx('learningIndicatorComponent', className)}
            style={style}
            onClick={onClick}
            iconLeft={<LearningIndicatorIcon />}
            variant="text"
        >
            {text}
        </ButtonSymphony>
    );
}

export default LearningIndicator;